module.exports = __webpack_public_path__ + "static/media/Resume_Edian_Reyes.ebbcfc9f.pdf";